import { CENTRAL_DOACOES_PERMISSIONS } from "constants/index";
import React, { Component } from "react";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import WidgetDialog from "../../../components/Dialog/dialog.component";
import Title from "../../../components/Title/title.component";
import centralDoacaoService from "../../../services/centralDoacaoService";
import MunicipioService from "../../../services/municipioService";
import { validatePermission } from "../../../utils/permissionHelper";
import ToastHelper from "../../../utils/toastHelper";
import ListagemContainer, {
	PesquisaAvancadaContext
} from "../../comum/containers/listagem.container";
import CadastraEntidade from "../cadastraEntidade/cadastraEntidade.modal";
import ModalCancelar from "../cancelarEntidade/cancelarEntidade.modal";
import EditarEntidade from "../editarEntidade/editEntidade.modal";
import VisualizaEntidade from "../visualizaEntidade/visualizaEntidade.modal";
import PesquisaAvancadaEntidade from "./pesquisaAvancadaEntidade";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

class ListaEntidades extends Component {
	state = {
		entidade: null,
		isOpenVisualizar: false,
		isOpenEditar: false,
		isOpenCancelarEntidade: false,
		filtro: {
			nome: "",
			cnpj: "",
			municipiosSelecionados: [],
			idMunicipios: [],
			simplificado: true,
			ordem: ""
		},
		pesquisaAvancada: false,
		municipios: [],
		orderIcon: {
			nome: "",
			icon: undefined
		},
		inititalOrderIcon: {
			colunaTable: "nome",
			iconOrderDirection: "fas fa-arrow-up"
		}
	};

	columns = [
		{
			id: 0,
			title: "CNPJ",
			property: "cnpj",
			order: "cnpj"
		},
		{
			id: 1,
			title: "Entidade",
			property: "nome",
			order: "nome"
		},
		{
			id: 2,
			title: "Município",
			property: "nomeMunicipio",
			order: "endereco.municipio.nome"
		}
	];

	/*
		** ATENÇÃO **

		NÃO ALTERAR A ORDEM DAS ACTIONS
		NÃO ALTERAR A ORDEM DAS ACTIONS
		NÃO ALTERAR A ORDEM DAS ACTIONS

		CASO SEJA EXTREMAMENTE NECESSÁRIO ALTERAR, FAÇA O SEGUINTE:
			- NÃO ALTERE

		CASO MESMO ASSIM QUERIA MUDAR, FAÇA ISSO:
			- MUDE A ORDEM ABAIXO
			- VÁ ATÉ O COMPONENTE DE:
				- LISTAGEM CONTAINER
			- PROCURE A FUNÇÃO checkActions, ESTÁ PERTO DO RENDER
			- ALTERE O RETORN DAS ACTIONS PARA A POSIÇÃO ATUAL DA ACTION VISUALIZAR
			- LEMBRANDO QUE ARRAY COMEÇA EM 0
	*/

	constructor(props) {
		super(props);
		this.child = React.createRef();
	}

	showGerenciar() {
		const { usuario } = this.props;
		return validatePermission(
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTIDADE,
			usuario.soeAcoes
		);
	}

	get actions() {
		return [
			{
				id: 0,
				name: "Visualizar",
				icon: "fas fa-search",
				enabled: item => !item.cancelado,
				action: item => this.handleVisualizarEntidade(item)
			},
			{
				id: 1,
				name: "Editar",
				icon: "fas fa-edit",
				action: item => this.handleEditarEntidade(item),
				enabled: item => !item.cancelado,
				checkRule: true,
				show: this.showGerenciar.bind(this)
			},
			{
				id: 2,
				name: "Cancelar",
				icon: "fas fa-times",
				action: item => this.handleCancelarEndidade(item),
				enabled: item => !item.cancelado,
				checkRule: true,
				show: this.showGerenciar.bind(this)
			}
		];
	}

	async componentDidMount() {
		const allMunicipios = await MunicipioService.findAll();
		this.setState({
			municipios: [...allMunicipios.data]
		});
	}

	/* VISUALIZAR ENTIDADE */
	handleVisualizarEntidade = async item => {
		const result = await centralDoacaoService.findEntidadeById(item.id);

		if (result) {
			this.setState({
				isOpenVisualizar: true,
				entidade: result.data
			});
		}
	};

	handleCloseVisualizar = () => {
		this.setState({ isOpenVisualizar: false });
	};

	createModalVisualizar = ({ entidade, isOpenVisualizar }) =>
		isOpenVisualizar && (
			<VisualizaEntidade
				isOpenVisualizar={isOpenVisualizar}
				handleCloseVisualizar={this.handleCloseVisualizar}
				entidade={entidade}
			/>
		);

	/* EDITAR ENTIDADE */
	handleEditarEntidade = async item => {
		const result = await centralDoacaoService.findEntidadeById(item.id);

		if (result) {
			this.setState({
				entidade: result.data,
				isOpenEditar: true
			});
		}
	};

	handleCloseEditar = () => {
		this.setState({ isOpenEditar: false });
	};

	handleSubmitEditar = async values => {
		await centralDoacaoService.salvarEntidade(values);
		ToastHelper.success("Edição concluída com sucesso.");
		this.handleCloseEditar();
		this.child.current.initialize();
	};

	createModalEditar = ({ entidade, isOpenEditar }) =>
		isOpenEditar && (
			<EditarEntidade
				isOpenEditar={isOpenEditar}
				handleCloseEditar={this.handleCloseEditar}
				handleSubmitEditar={this.handleSubmitEditar}
				entidade={entidade}
			/>
		);

	/* MODAL CANCELAR ENTIDADE */
	handleCancelarEndidade = async item => {
		const res = await centralDoacaoService.findEntidadeById(item.id);
		const oficiosResp = await centralDoacaoService.findOficiosByEntidade(
			item
		);

		const entidadeSalva = {
			...res.data,
			oficios: oficiosResp.data
		};

		this.setState(prevState => ({
			...prevState,
			entidade: entidadeSalva,
			isOpenCancelarEntidade: true
		}));
	};

	createModalCancelar = ({ isOpenCancelarEntidade, entidade }) => {
		if (isOpenCancelarEntidade) {
			const todosOficiosCancelados =
				entidade.oficios.filter(oficio => oficio.cancelado).length ===
				entidade.oficios.length;

			if (todosOficiosCancelados) {
				return (
					<ModalCancelar
						entidade={entidade}
						isOpenCancelar={isOpenCancelarEntidade}
						handleCloseCancelar={() =>
							this.setState(prevState => ({
								prevState,
								isOpenCancelarEntidade: false
							}))
						}
						handleSubmitCancelar={async () => {
							await centralDoacaoService.cancelarEntidade({
								...entidade,
								cancelado: true
							});
							ToastHelper.success(
								"Entidade cancelada com sucesso."
							);
							this.setState(prevState => ({
								prevState,
								isOpenCancelarEntidade: false
							}));
							this.child.current.initialize();
						}}
					/>
				);
			}

			return (
				<WidgetDialog
					title="Atenção!"
					isOpen={isOpenCancelarEntidade}
					textConfirmar="Ok"
					mensagem="Não é possível cancelar esta entidade pois está vinculada a um ofício."
					confirmar={() => {
						this.setState({ isOpenCancelarEntidade: false });
					}}
				/>
			);
		}

		return false;
	};

	/* Filtro */
	handlePesquisaSimplificada = () => {
		const prevState = this.state;
		prevState.filtro.simplificado = true;
		prevState.pesquisaAvancada = false;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
		this.child.current.limpaCampoPesquisaSimplificada();
	};

	ordenar = ordem => {
		const direcaoOrdemFiltro = this.child.current.handleSearchByOrder(
			ordem,
			false
		);

		if (direcaoOrdemFiltro === "DESC") {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-down", nomeColuna: ordem }
			});
		} else {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-up", nomeColuna: ordem }
			});
		}
	};

	handlePesquisaAvancada = () => {
		const prevState = this.state;
		prevState.filtro.simplificado = false;
		prevState.pesquisaAvancada = true;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
	};

	resetIconOrder = () => {
		this.setState({ orderIcon: { icon: undefined, nomeColuna: "" } });
	};

	handleReload() {
		this.child.current.initialize();
	}

	render() {
		const {
			municipios,
			pesquisaAvancada,
			filtro,
			orderIcon,
			inititalOrderIcon
		} = this.state;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">
						<Title>Entidades</Title>
					</div>
				</div>

				<ListagemContainer
					ref={this.child}
					columns={this.columns}
					actions={this.actions}
					listaTitle="Listagem de entidades"
					pesquisaTitle={null}
					servicePaginacao={centralDoacaoService.findAllEntidades}
					serviceSearch={centralDoacaoService.findAllEntidades}
					serviceCadastrar={centralDoacaoService.salvarEntidade}
					titleButtonCadastrar="Cadastrar entidade"
					emptyMessage="Não há entidades cadastradas."
					ComponenteCadastrar={CadastraEntidade}
					searchPlaceHolder="Pesquise por entidade"
					toastMessage="Entidade cadastrada com sucesso"
					trClass={entidade =>
						entidade.cancelado ? "cancelado" : ""
					}
					pesquisaAvancada={pesquisaAvancada}
					isPesquisaAvancada
					handlePesquisaAvancada={this.handlePesquisaAvancada}
					ordenar={this.ordenar}
					isOrderByGrid
					orderIcon={orderIcon}
					inititalOrderIcon={inititalOrderIcon}
					entidade
					permission={CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR}
					permissionCadastrar={
						CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTIDADE
					}
				>
					<PesquisaAvancadaContext.Consumer>
						{() => (
							<PesquisaAvancadaEntidade
								municipios={municipios}
								filtro={filtro}
								handlePesquisaSimplificada={
									this.handlePesquisaSimplificada
								}
								serviceSearch={values => {
									this.setState({
										pesquisaAvancada: { ...values }
									});
									this.child.current.manualSearch(
										centralDoacaoService.findAllEntidades,
										values
									);
								}}
								resetIconOrder={this.resetIconOrder}
							/>
						)}
					</PesquisaAvancadaContext.Consumer>
				</ListagemContainer>
				{this.createModalVisualizar(this.state)}
				{this.createModalEditar(this.state)}
				{this.createModalCancelar(this.state)}
			</React.Fragment>
		);
	}
}

export default connect(mapStateToProps)(ListaEntidades);
